export const DEFAULT_LANGUAGE = 'endefault'
export const AVAILABLE_BPOST_COUNTRIES_CODE = ['NL', 'BE', 'LU', 'FR']
